module.exports = __webpack_public_path__ + "img/banner_contact_1920x226.0a098dfc.jpg";